<template>
  <main>
    <RouterView />
  </main>
</template>
<script></script>
